import { Reducer } from 'redux';
import { GarageTypes, GarageState } from './types';

const INITIAL_STATE: GarageState = {
  garageData: {
    id: '',
    name: '',
    phone: '',
    cnpj: '',
    address: '',
    bounds: [],
    createdAt: '',
    updatedAt: '',
    GarageQuantities: [],
    GarageServices: [],
    TransportSupervisor: {
      id: '',
      name: '',
      email: '',
    },
  },
  garageList: [],
  totalCount: 0,
  error: false,
  loading: false,
};

const reducer: Reducer<GarageState> = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    // CASES LIST GARAGE
    case GarageTypes.LIST_GARAGE_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        garageList: INITIAL_STATE.garageList,
      };

    case GarageTypes.LIST_GARAGE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        garageList: action.payload.garageList,
        totalCount: action.payload.totalCount,
      };

    case GarageTypes.LIST_GARAGE_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        garageList: INITIAL_STATE.garageList,
      };

    // CASES GET GARAGE
    case GarageTypes.GET_GARAGE_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        garageData: INITIAL_STATE.garageData,
      };

    case GarageTypes.GET_GARAGE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        garageData: action.payload.garageData,
      };

    case GarageTypes.GET_GARAGE_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        garageData: INITIAL_STATE.garageData,
      };

    // CASES FILTER GARAGE
    case GarageTypes.FILTER_GARAGE_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        garageList: INITIAL_STATE.garageList,
      };

    case GarageTypes.FILTER_GARAGE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        garageList: action.payload.garageList,
        totalCount: action.payload.totalCount,
      };

    case GarageTypes.FILTER_GARAGE_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        garageList: INITIAL_STATE.garageList,
      };

    // CASES CREATE GARAGE
    case GarageTypes.CREATE_GARAGE_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        garageData: INITIAL_STATE.garageData,
      };

    case GarageTypes.CREATE_GARAGE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        garageData: action.payload.garageData,
      };

    case GarageTypes.CREATE_GARAGE_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        garageData: INITIAL_STATE.garageData,
      };

    // CASES UPDATE GARAGE
    case GarageTypes.UPDATE_GARAGE_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
      };

    case GarageTypes.UPDATE_GARAGE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        garageData: action.payload.garageData,
      };

    case GarageTypes.UPDATE_GARAGE_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
      };

    // CASES DELETE GARAGE
    case GarageTypes.DELETE_GARAGE_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
      };

    case GarageTypes.DELETE_GARAGE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
      };

    case GarageTypes.DELETE_GARAGE_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
      };

    default:
      return state;
  }
};

export default reducer;
